<div class="dialog-wrapper">
  <div class="dialog-header">
    <h1 mat-dialog-title>{{ data.heading }}</h1>
  </div>
  <div mat-dialog-content>
    <div class="gsm-form_container">
      <dynamic-material-form
        [model]="formModel"
        [group]="formGroup"
        (change)="onChange($event)"
        (matEvent)="data.parentComponent.onCustomEvent($event, null, true)"
      ></dynamic-material-form>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancelClick()">{{ data.disabled ? 'Schließen' : 'Abbrechen' }}</button>
    <button
      *ngIf="!data.disabled"
      mat-button
      mat-raised-button
      color="primary"
      (click)="onApplyClick()"
      [disabled]="formInvalid"
      data-test="uebernehmen-btn"
    >
      Übernehmen
    </button>
  </div>
</div>
